// extracted by mini-css-extract-plugin
export default {"informationBox":"Popover_informationBox__ErVND"};